module.exports = {
      id: "appstore-usage",
      viewBox: "0 0 120 40",
      url: __webpack_public_path__ + "svg-sprite-c16dead317bf40daa0a857495c90b974.svg#appstore",
      toString: function () {
        return this.url;
      }
    }